module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "a09_toc"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_xvii"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_vm._v("Contents")])]), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "id": "page_xvii"
    }
  }), _c('a', {
    attrs: {
      "href": "#/07_preface"
    }
  }, [_vm._v("PREFACE")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('a', {
    attrs: {
      "href": "#/13_part1"
    }
  }, [_vm._v("PART I. THE BATTLE OF JUTLAND")])]), _vm._v(" "), _c('p', {
    staticClass: "tocb"
  }, [_vm._v("31 May-1 June 1916")]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/14_ch1"
    }
  }, [_vm._v("CHAPTER I. JELLICOE’S TACTICS: THE GRAND FLEET BATTLE ORDERS (The Eve of Jutland)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/14_ch1#sec1"
    }
  }, [_vm._v("1. MOTIVATING FACTORS AND MAIN CONCEPTIONS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_vm._v("Tactical thought in pre-war days—Jellicoe issues his Grand Fleet Battle Orders—Reasons for their defensive tone: the supreme importance of the Grand Fleet—The menace of torpedoes, mines, and submarine-and-mine traps—Precautions arising from these threats—Another factor: the strained Anglo-American relations—The absence of surprise in the G.F.B.O.s—The single line of the plan of battle—The arguments for and against ‘divided’ tactics—The manœuvre of ‘crossing the T’—Long range and parallel courses—Jellicoe’s reliance on the big gun—Centralized command—Callaghan and Beatty advocate less centralized methods—Centralization and decentralization principles in the G.F.B.O.s—The reasons for the centralization in practice.")]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/14_ch1#sec2"
    }
  }, [_vm._v("2. EMPLOYMENT OF LIGHT FORCES AND BATTLE CRUISERS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_vm._v("The defensive role of the smaller ships—Differing views on the function of destroyers—Why Jellicoe gave them a primarily defensive role—Role of the armoured, light, and battle cruisers.")]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/14_ch1#sec3"
    }
  }, [_vm._v("3. NIGHT FIGHTING")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_vm._v("The lack of interest in night battle between the larger units—The confusion and uncertainties of a night action—The lack of the ‘tools’ for night battle—The G.F.B.O.s and a night action.")]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/14_ch1#sec4"
    }
  }, [_vm._v("4. CRITIQUE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_vm._v("The G.F.B.O.s assume a German wish to fight—Alternatives if the enemy were unwilling to fight—Excessive detail of the G.F.B.O.s—The consequence—A co-ordinated weapon offensive insufficiently considered—Jellicoe’s reluctance to alter his basic principles—Sturdee’s tactical ideas—A summary statement on the G.F.B.O.s—A note on tactics.")]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/15_ch2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER II. JUTLAND: THE BATTLE-CRUISER PHASE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1a"
  }, [_vm._v("(31 May 1916, to 5.56 p.m.)")]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/15_ch2#sec1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1. PRELIMINARIES")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_vm._v("The German plan—Composition of the High Seas Fleet—Scheer’s U-boat trap fails—The Grand Fleet puts to sea—Its "), _c('a', {
    attrs: {
      "id": "page_xviii"
    }
  }, [_vm._v("composition—Portraits of Jellicoe and the battle-squadron commanders—Beatty and the battle-cruiser commanders—The light-cruiser squadron commanders—The Commodore of Destroyer Flotillas and the destroyer captains—Fleet morale—The ‘flagship in Jade’ blunder—The "), _c('i', [_vm._v("Campania")]), _vm._v(" incident—The Harwich Force is held on a leash—The problem of the spread between Jellicoe and Beatty—And of the disposition of the 5th Battle Squadron.")])]), _c('a', {
    attrs: {
      "id": "page_xviii"
    }
  }), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "id": "page_xviii"
    }
  }), _c('span', {
    attrs: {
      "href": "#/15_ch2#sec2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2. CONTACT")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_vm._v("Approach of the two battle-cruiser fleets—The "), _c('i', [_vm._v("Galatea")]), _vm._v(" sights the enemy—Beatty’s alteration of course—Why the 5th Battle Squadron did not turn at the same time as the "), _c('i', [_vm._v("Lion")]), _vm._v(" to S.S.E.— Beatty’s light cruisers ‘march to the sound of the guns’—The "), _c('i', [_vm._v("Engadine")]), _vm._v(" launches a seaplane—Beatty and Hipper sight each other—Beatty opens fire.")]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/15_ch2#sec3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. THE RUN TO THE SOUTH")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_vm._v("A parallel action develops—The near-fatal hit on the "), _c('i', [_vm._v("Lion")]), _vm._v("— The destruction of the "), _c('i', [_vm._v("Indefatigable")]), _vm._v("—The 5th Battle Squadron comes into action—The "), _c('i', [_vm._v("Queen Mary")]), _vm._v(" blows up—Beatty’s famous remark—The destroyer action—The "), _c('i', [_vm._v("Southampton")]), _vm._v(" sights the German battle fleet—Beatty falls back on Jellicoe—Goodenough holds on—The 5th Battle Squadron’s delayed reaction to Beatty’s signal to turn—The charges against Beatty "), _c('i', [_vm._v("re")]), _vm._v(" the run to the south—The pros and cons—A summary statement.")]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/15_ch2#sec4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4. THE RUN TO THE NORTH")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_vm._v("The first phase—The second phase: British advantages— Appearance of the 3rd Battle Cruiser Squadron—Its consequences—"), _c('i', [_vm._v("Résumé")]), _vm._v("—Criticisms of the Battle Cruiser Fleet— Beatty’s case—The 5th Battle Squadron and enemy reports— The battle cruisers make contact with the battle fleet.")]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/16_ch3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER III. THE BATTLE FLEETS IN ACTION")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1a"
  }, [_vm._v("(31 May, 5.56 p.m.–"), _c('i', [_vm._v("c")]), _vm._v(". 9 p.m.)")]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/16_ch3#sec1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1. THE DEPLOYMENT OF THE BATTLE FLEET")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_vm._v("Jellicoe’s initial movements—Beatty’s mutilated message— Cruising formation of the battle fleet—The problem of deployment—Jellicoe is poorly served by his cruisers—The incomplete visual chain—Jellicoe’s light-cruiser screen and advanced scout line—The differences in dead reckoning positions—The "), _c('i', [_vm._v("Marlborough")]), _vm._v(" sights the battle cruisers—Jellicoe’s calculations are thrown off—Beatty’s enemy reports—The imperative need for a decision on deployment—The disadvantages of deployment on the starboard wing—The advantages of a deployment to port—Criticisms of Jellicoe’s decision—Tributes to his deployment—The alternative of a deployment on a centre column— The Tactical School demonstration—Visibility conditions.")]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/16_ch3#sec2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2. THE FIRST ENCOUNTER")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_vm._v("Jellicoe gives the order for deployment—Beatty takes up his station—The 5th Battle Squadron moves to the rear of the line— "), _c('a', {
    attrs: {
      "id": "page_xix"
    }
  }, [_vm._v("The difficulties of the "), _c('i', [_vm._v("Warspite—")]), _vm._v("The loss of the "), _c('i', [_vm._v("Defence")]), _vm._v("—A justification of Arbuthnot’s tactics—The end of the "), _c('i', [_vm._v("Invincible—")]), _vm._v(" The tragic episode of the survivors—The two main fleets in action—The hapless "), _c('i', [_vm._v("Wiesbaden")]), _vm._v("—Condition of the German battle cruisers—Gunnery statistics—The situation at ‘Windy Corner’—Scheer’s predicament—He orders the ‘battle about-turn’—Jellicoe’s alternatives—His decision—The criticism of Beatty’s ‘failure to regain touch’—Beatty’s 32-point turn— Goodenough’s bold reconnaissance—Criticisms of Jellicoe’s tactics during deployment.")])]), _c('a', {
    attrs: {
      "id": "page_xix"
    }
  }), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "id": "page_xix"
    }
  }), _c('span', {
    attrs: {
      "href": "#/16_ch3#sec3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. THE SECOND ENCOUNTER")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_vm._v("Scheer turns to the east—His reasons—His probable intention —The critical situation of the German fleet—How Scheer extricated himself—His flotillas attack—How Jellicoe countered the attack—His turn-away: pros and cons.")]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/16_ch3#sec4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4. THE LAST DAYLIGHT ACTIONS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_vm._v("The courses steered by the battle fleet—Beatty’s ‘follow me’ signal—His reasons for the signal—Why it could not be carried out—The later controversy over it—Scheer’s position and strategy—The light-cruiser skirmish—Beatty’s action with the 1st Scouting Group—The "), _c('i', [_vm._v("Caroline")]), _vm._v(" and "), _c('i', [_vm._v("Royalist")]), _vm._v(" sight enemy battleships—Missed opportunities—The situation around 9 p.m.—A note on Beatty’s 32-point turn.")]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/18_ch4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER IV. JUTLAND: THE NIGHT ACTION")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1a"
  }, [_vm._v("(31 May, "), _c('i', [_vm._v("c.")]), _vm._v(" 9 p.m.-1 June, forenoon)")]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/18_ch4#sec1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1. DISPOSITIONS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_vm._v("Jellicoe rejects a night action between the main fleets—His reasons—The course and formation of the battle fleet—Beatty alters course to south—The disclosure of the secret recognition signal—The question of Scheer’s probable route home— Jellicoe’s deduction—Criticism of it—Jellicoe’s confidence— Course and formation of the High Seas Fleet—Scheer’s aim.")]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/18_ch4#sec2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2. NIGHT ACTIONS AND SCHEER’S ESCAPE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_vm._v("The first encounter: the German 7th Flotilla and the British 4th Flotilla—The second encounter: the 2nd Scouting Group and the British 11th Flotilla—The third encounter: the 4th Scouting Group and the 2nd Light Cruiser Squadron—The fourth encounter: the German battle fleet and the British 4th Flotilla—The High Seas Fleet passes astern of the British battle fleet—The fifth encounter: the High Seas Fleet and British flotillas—The sixth encounter: the High Seas Fleet and the British 12th Flotilla—The seventh encounter: the ‘Deutsch-lands’ and the light cruiser "), _c('i', [_vm._v("Champion")]), _vm._v(" and destroyers—Epilogue: German destroyers elude the "), _c('i', [_vm._v("Champion")]), _vm._v(" and destroyers—The ineffectiveness of the British flotillas—Jellicoe’s views on the destroyers—The Admiralty’s signal of 10.41 p.m.—Their signal of 9.58 p.m.—The messages from the "), _c('i', [_vm._v("Birmingham")]), _vm._v(" and "), _c('i', [_vm._v("Nottingham")]), _vm._v("—Scheer’s airship reconnaissance signal—The Operations Division and other intercepted signals—Significance of the Admiralty neglect to pass on these signals—What was wrong: "), _c('a', {
    attrs: {
      "id": "page_xx"
    }
  }, [_vm._v("the secrecy fetish, the organization of the Operations Division —The specific responsibility during the night of Jutland—What did the firing astern indicate?—Sightings are not reported to Jellicoe—A defence of the 5th Battle Squadron— Grand Fleet instructions on the use of wireless—The night position of the battle fleet must not be disclosed—Jellicoe’s impressions during the night—The exhaustion of the officers.")])]), _c('a', {
    attrs: {
      "id": "page_xx"
    }
  }), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "id": "page_xx"
    }
  }), _c('span', {
    attrs: {
      "href": "#/18_ch4#sec3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. DAWN AND THE MORNING AFTER")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_vm._v("The High Seas Fleet reaches Horns Reef—Scheer abandons further operations—Jellicoe realizes the bird has flown—The Grand Fleet searches for enemy stragglers—It heads for its bases—U-boat attacks on the fleet—The role of the British submarines.")]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/19_part2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PART II. JUTLAND: THE AFTERMATH")])]), _vm._v(" "), _c('p', {
    staticClass: "tocb"
  }, [_vm._v("June 1916–November 1916")]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/20_ch5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER V. JUTLAND: COMPARISONS AND REFLECTIONS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/20_ch5#sec1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1. "), _c('i', [_vm._v("MATÉRIEL")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_vm._v("German shooting: pluses and minuses—Statistics of hits—Why the German ships were nearly unsinkable—Ineffectiveness of the British armour-piercing shell—Responsibility of the Ordnance Board—Armour protection of the British battle cruisers—The importance of the magazines not being flashtight—German and British propellants.")]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/20_ch5#sec2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2. NON-"), _c('i', [_vm._v("MATÉRIEL")]), _vm._v(" FACTORS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_vm._v("British signal communications—German jamming—The British challenge procedure—British intelligence and reconnaissance— The lack of initiative—British and German use of destroyers— The destroyers do not come up to expectation—Opportunities missed of firing torpedoes.")]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/20_ch5#sec3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. TACTICS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_vm._v("Appraisal of Hipper and Scheer—Beatty’s performance—Criticisms of Jellicoe’s conduct of the fleet—Centralization in command—The ‘mass of signals’—The long rigid line—Night action—Jellicoe’s primary object—The key to the Jutland problem—If Beatty had been in command.")]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/21_ch6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER VI. JUTLAND: EVALUATION (June-July 1916)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/21_ch6#sec1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I. REACTIONS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_vm._v("The Germans claim a victory—Initial opinion in the Grand Fleet—The continued faith in Jellicoe—His own deep disappointment—Beatty’s reactions to the battle—The shock of the fleet on returning to port—The Admiralty’s first communiqué—How it was received—The second and third communiqués—Public opinion does an about-face—The publication of Jellicoe’s dispatch—The beginnings of the Jutland Controversy.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_xxi"
    }
  }), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "id": "page_xxi"
    }
  }), _c('span', {
    attrs: {
      "href": "#/21_ch6#sec2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2. RESULTS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_vm._v("Ship losses—The Admiralty seek replacements from Japan— Casualties—Damaged capital ships—Significance of "), _c('i', [_vm._v("matériel")]), _vm._v(" losses and casualties—Strategically, the Grand Fleet is the winner—German admissions—Reasons for British dissatisfaction—Comments thereon—The effects of a decisive British victory—Qualifications on these claims—The ‘control of communications’ school of thought—How the Navy responded to the results of Jutland.")]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/22_ch7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER VII. THE POST-JUTLAND REFORMATION"), _c('br'), _vm._v("(June-November 1916)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/22_ch7#sec1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1. SWEEPING CHANGES IN "), _c('i', [_vm._v("MATÉRIEL")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_vm._v("Technical committees—Completion of fitting of directors— Changes in fire control—Other gunnery developments—The shell problem—The flash problem—Armour protection— Improvement in intelligence arrangements—Reorganization of Room 40.")]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/22_ch7#sec2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2. THE NEW TACTICS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_vm._v("Continuation of dominant conceptions in G.F.B.O.s—More decentralization in command and greater flexibility of the line —Counters to torpedo attack—Offensive destroyer tactics— Deployment on a centre column—New position of 5th Battle Squadron—Provisions for a night action—Employment of Grand Fleet submarine flotillas.")]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/22_ch7#sec3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. PROBLEMS IN STRATEGY")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_vm._v("Strategical relations of the Battle Cruiser Fleet and battle fleet —The Battle Cruiser Fleet and a ‘superior force’—Function of the 5th Battle Squadron—Employment of Harwich Force.")]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/23_part3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PART III. END OF THE FIRST PHASE")])]), _vm._v(" "), _c('p', {
    staticClass: "tocb"
  }, [_vm._v("August 1916-December 1916")]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/24_ch8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER VIII. THE GRAND FLEET AFTER JUTLAND")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1a"
  }, [_vm._v("(August-November 1916)")]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/24_ch8#sec1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1. BLIND MAN’S BUFF, 19 AUGUST 1916")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_vm._v("Scheer’s strategic thinking after Jutland—He plans a new operation—The High Seas Fleet sails—British preparations— The Grand Fleet sails—Disposition of the Harwich Force and submarines—The "), _c('i', [_vm._v("Nottingham")]), _vm._v(" torpedoed—The Grand Fleet turns north—The Grand Fleet turns south—Imminence of action—Scheer’s movements—Zeppelin reports—Scheer returns to base—The Grand Fleet retires—The Harwich Force contacts the High Seas Fleet—And abandons the pursuit.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_xxii"
    }
  }), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "id": "page_xxii"
    }
  }), _c('span', {
    attrs: {
      "href": "#/24_ch8#sec2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2. RESULTS OF 19 AUGUST")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_vm._v("Jellicoe’s cautious strategy—Scheer’s evaluation of the sortie— The German Naval Staff curbs further sorties—British reaction to 19 August—Jellicoe urges aerial scouting for the Grand Fleet—He stresses the destroyer shortage—The Admiralty’s position on destroyers—13 September conference on North Sea strategy—The decision to keep the Grand Fleet north of the Horns Reef parallel—‘Exceptional circumstances’ are allowed for—The Admiralty are impatient with the Grand Fleet’s defensive strategy—The stalemate in the North Sea—The High Seas Fleet sortie of 19 October—Grand Fleet strategy— Results—Two German dreadnoughts are torpedoed.")]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/25_ch9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER IX. END OF THE BALFOUR-JACKSON RÉGIME")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1a"
  }, [_vm._v("(November-December 1916)")]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/25_ch9#sec1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1. THE ADMIRALTY UNDER FIRE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_vm._v("The German destroyer raid in the Channel, 26-27 October— Difficulties in countering such raids—The Admiralty communiqué—Press reaction to the raid—Balfour’s assurances at the Lord Mayor’s banquet—Repetition of the raid, 23 November—Press reaction—The wrangle over the Air Board— Curzon’s indictment of the Admiralty—The press sides with the Air Board—Churchill’s "), _c('i', [_vm._v("London Magazine")]), _vm._v(" article—It provokes a spirited controversy—How the Admiralty and Fleet viewed the matter—Summary of questions raised in the controversy—Admiralty assurances on the offensive strategy of the Fleet—The anti-Admiralty campaign is intensified.")]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/25_ch9#sec2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2. THE STEPPED-UP U-BOAT OFFENSIVE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_vm._v("The lull in the U-boat campaign—Flare-up of a new campaign —Its disturbing features—The plus factors in the situation— U-boat loss figures—Anti-submarine measures—The Dover Straits a sieve—The gloomy situation in the Mediterranean— Frustration of the British command in the Adriatic—Ineffectiveness of the patrolled shipping lanes in the Mediterranean— Public agitation on the U-boat question.")]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/25_ch9#sec3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. THE SHAKE-UP IN THE NAVY HIGH COMMAND")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_vm._v("Jellicoe realizes the gravity of the U-boat menace—His suggestions for dealing with it—Balfour’s attitude towards the threat—The 2 November War Committee meeting—The 3 November Admiralty conference—Discussion of Jellicoe coming to the Admiralty—The Admiralty mark time—Jackson is asked to resign—Jellicoe accepts the post of First Sea Lord— Beatty succeeds Jellicoe—Jerram and Sturdee are asked to haul down their flags—The press intensifies its anti-Balfour campaign—He resigns—Fisher’s supporters come to life— Carson succeeds Balfour.")]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/26_appendix",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("APPENDIX")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/27_appendix01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("APPENDIX. ORGANIZATION OF THE GRAND FLEET")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1b"
  }, [_c('span', {
    attrs: {
      "href": "#/27_appendix01#sec1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ORGANIZATION OF THE GERMAN FLEET")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/28_index",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("INDEX")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-71005729","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/09_toc.vue
// module id = 81
// module chunks = 0